module.exports = {"printSelected":"Print selected","dymoPrintSelected":"Dymo Print selected","exportCSV":"Export CSV","previous":"Previous","next":"Next","msg":{"transactionReleased":"Transaction successfully released.","ticketReleased":"Ticket successfully released.","transactionDeleted":"Transaction successfully deleted.","ticketDeleted":"Ticket successfully deleted.","noResults":"No result has been found with your search criteria. Please try something else.","emailSuccess":"Email sent successfully.","noArchives":"There was no Archived Transactions for that user."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/locales/en.json
// module id = 1402
// module chunks = 0